export default __webpack_public_path__ + "static/media/training.881c13a1.png";